export const contractServiceEos = [
  "contractserviceseo@go4.io",
]

export const isContractEo = email => {
  return contractServiceEos.includes(email);
}
